import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const escrowPrintCheckUrl = (checkId: string) =>
  `${baseUrlService.ApiLocation}/timber/api/internal/escrow/escrow_manual_check_disbursements/${encodeURIComponent(
    checkId
  )}/print_manual_check`;

export const escrowPrintCheckUrlAndSetDate = (checkId: string) =>
  `${baseUrlService.ApiLocation}/timber/api/internal/escrow/escrow_manual_check_disbursements/${encodeURIComponent(
    checkId
  )}/print_manual_check_and_set_check_date`;
